package one.healthium.insights.ui.insights.models

import androidx.compose.runtime.Immutable

@Immutable
data class SpaceUiModel(
    val valueDp: Int,
)
